<template>

  <main class="main-content" id="topDom">
    <section class="section --banner">
      <div class="banner">
        <div class="banner__bg">
          <img :src="bgImg" />
        </div>
        <div class="banner__content container-fluid">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ $t("i18n.retrievePasswordText") }}</h1>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="register-header">
              <div class="register-header-text">
                <h1>{{ $t("i18n.retrievePasswordText") }}</h1>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="register-form">
              <div class="register-title">
                <div class="register-title-text">
                  <span>{{ $t("i18n.retrievePassword") }}</span>
                </div>
              </div>
              <div class="register-input">
                <div class="register-input-text">{{ $t('i18n.retrieveList[0].name') }}</div>
                <input type="text" class="form-input" :placeholder="$t('i18n.retrieveList[0].text')" v-model="form.company">
                <span class="invalid-feedback">{{ $t('i18n.retrieveList[0].required') }}</span>
              </div>
              <div class="register-input">
                <div class="register-input-text">{{ $t('i18n.retrieveList[1].name') }}</div>
                <input type="text" class="form-input --phone" :placeholder="$t('i18n.retrieveList[1].text')" v-model="form.mobile">
                <span class="invalid-feedback">{{ $t('i18n.retrieveList[1].required') }}</span>
              </div>
              <div class="register-input --name">
                <div class="register-input-text">{{ $t('i18n.retrieveList[2].name') }}</div>
                <input type="text" class="form-input --name" :placeholder="$t('i18n.retrieveList[2].text')" v-model="form.truename">
              </div>
              <div class="register-input">
                <div class="register-input-text">{{ $t('i18n.retrieveList[3].name') }}</div>
                <input type="passWord" class="form-input --password" :placeholder="$t('i18n.retrieveList[3].text')" v-model="form.password">
                <span class="invalid-feedback">{{ $t('i18n.retrieveList[3].required') }}</span>
              </div>
              <div class="register-input">
                <div class="register-input-text">{{ $t('i18n.retrieveList[4].name') }}</div>
                <input type="passWord" class="form-input --rePassword" :placeholder="$t('i18n.retrieveList[4].text')" v-model="form.repassword">
                <span class="invalid-feedback">{{ $t('i18n.retrieveList[4].required') }}</span>
              </div>
              <div class="register-input">
                <div class="register-input-text" v-html="$t('i18n.retrieveList[5].name')"></div>
                <input type="text" class="form-input" :placeholder="$t('i18n.retrieveList[5].text')" v-model="form.code">
                <div class="code-btn" v-if="!codeFlg" @click="getCode">{{ $t('i18n.retrieveList[5].button') }}</div>
                <div class="code-btn" v-else>{{ $t('i18n.retrieveList[5].reP') + countdown }}</div>
              </div>
              <div class="register-checkbox">
                <label class="checkbox">
                  <input type="checkbox" name="privacy_policy" value="1" class="checkbox__input" v-model="form.check">
                  <span class="checkbox__checkmark"></span>
                  <div  class="checkbox__label">
                    <span>{{ $t('i18n.readAndAgree') }}</span>
                    <a class="register-checkbox-text">{{ $t('i18n.protocol') }}</a>
                  </div>
                </label>
              </div>
              <div class="register-btn" @click="submit">{{ $t('i18n.confirm') }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {forgetPwd, sendCode} from "../api/api";
import {Message} from "element-ui";
export default {
  name: "retrievePassword",
  data() {
    return {
      flg: false,
      form: {},
      bgImg: this.isMobile() ? require("../assets/imgs/loginBg.png") : require("../assets/imgs/loginBg.png"),
      codeFlg: false,
      countdown: 0, // 倒计时的秒数
      timer: null, // 计时器
    }
  },
  // created() {
  //   this.goTop();
  // },
  mounted () {
    this.goTop();
  },
  methods: {
    submit() {
      if (!this.formValid()) {
        return;
      }
      forgetPwd(this.form).then(res => {
        if (res.data && res.data.code) {
          Message({
            message: this.$t('i18n.retrievePasswordTextR'),
            // message: error.message,
            type: 'success',
            duration: 3 * 1000
          });
          localStorage.setItem("token", res.data.token);
          this.$store.commit('updateLogin', true);
          this.flg = true;
          this.form = {};
          this.$router.push("/");
        } else {
          Message({
            message: res.data.msg,
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
        }
      });

    },
    getCode() {
      if (!this.form.mobile) {
        Message({
          message: this.$t('i18n.registeredList[1].required'),
          // message: error.message,
          type: 'error',
          duration: 3 * 1000
        });
        return false;
      }

      if (this.timer) return;

      this.codeFlg =true;
      this.countdown = 60; // 假设倒计时60秒

      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          this.codeFlg =false;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);

      sendCode({mobile: this.form.mobile}).then(res => {
        if (res && res.data) {
          Message({
            message: this.$store.state.language === '中文' ? '已发送' : "Has been sent",
            // message: error.message,
            type: 'success',
            duration: 3 * 1000
          });
        }
      });
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    toPage(path) {
      this.$router.push(path)
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // setTimeout(()=>{
      //   document.querySelector('#topDom').scrollIntoView({
      //     behavior: 'smooth'
      //   })
      // },100)
    },
    formValid() {
      if (!this.form.company) {
        Message({
          message: this.$t('i18n.registeredList[0].required'),
          // message: error.message,
          type: 'error',
          duration: 3 * 1000
        });
        return false;
      }
      if (!this.form.mobile) {
        Message({
          message: this.$t('i18n.registeredList[1].required'),
          // message: error.message,
          type: 'error',
          duration: 3 * 1000
        });
        return false;
      }
      if (!this.form.code) {
        Message({
          message: this.$t('i18n.registeredList[2].text'),
          // message: error.message,
          type: 'error',
          duration: 3 * 1000
        });
        return false;
      }
      if (!this.form.truename) {
        Message({
          message: this.$t('i18n.registeredList[3].text'),
          // message: error.message,
          type: 'error',
          duration: 3 * 1000
        });
        return false;
      }
      if (!this.form.password) {
        Message({
          message: this.$t('i18n.registeredList[4].required'),
          // message: error.message,
          type: 'error',
          duration: 3 * 1000
        });
        return false;
      } else {
        let regex = /^[a-zA-Z0-9]{6,20}$/;
        if (!regex.test(this.form.password)) {
          Message({
            message: this.$t('i18n.registeredList[4].required'),
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
          return false;
        }
      }
      if (!this.form.repassword) {
        Message({
          message: this.$t('i18n.registeredList[5].required'),
          // message: error.message,
          type: 'error',
          duration: 3 * 1000
        });
        return false;
      } else {
        if (this.form.repassword !== this.form.password) {
          Message({
            message: this.$t('i18n.registeredList[5].required'),
            // message: error.message,
            type: 'error',
            duration: 3 * 1000
          });
          return false;
        }
      }
      if (!this.form.check) {
        Message({
          message: this.$t('i18n.checkText'),
          // message: error.message,
          type: 'error',
          duration: 3 * 1000
        });
        return false;
      }
      return true;
    },
  },
}
</script>

<style scoped>

.banner {
  height: 64rem;
  align-items: center;
  display: flex;
}
.banner__bg {
  position: absolute;
  width: 100%;
  height: 64rem;
}
.banner__bg {
  z-index: 1;
}

.banner__bg img {
  max-width: 100%;

  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%;
}
img {
  max-width: 100%;
}
.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-size: 3.8rem;
  letter-spacing: -.084rem;
  line-height: 6rem;
  margin-bottom: 2rem;
  padding-right: 2rem;
  color: #FFFFFF;
  font-weight: 400;
}

.register-header {
  width: 100%;
  height: 6rem;
  background-color: #5A246B;
  margin-top: 10rem;
  border-radius: 1rem;
}
.register-header-text {
  color: #FFFFFF;
  font-size: 2rem;
  letter-spacing: -.022rem;
  line-height: 4rem;
  font-weight: normal;
  padding-top: 1rem;
  margin-left: 6rem;
}
.register-header-text h1 {
  margin: 0;
}
.register-header-text:after {
  content: "";
  width: 3.5rem;
  height: 3.5rem;
  background: url(../assets/imgs/select-arrow-big.png) no-repeat 50%;
  position: absolute;
  left: 50rem;
  bottom: 1rem;
}

.register-title {
  border-bottom: 1px solid #ddd;
  margin-top: 3rem;
  margin-bottom: 3rem;
  color: #5A246B;
}
.register-title-text {
  display: flex;
  justify-content: center;
  margin-right: 0.2rem;
  padding: 1rem 1.5rem;
  border: 1px solid #d2d0cf;
  border-bottom-color: transparent;
  cursor: pointer;
  background-color: #fff;
  width: 15rem;
  margin-left: 4%;
  margin-bottom: -.2rem;
  font-size: 16px;
  font-weight: 600;
}
.register-form {
  margin-bottom: 3rem;
  padding: 0 20rem;
}
.register-input {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-top: 3rem;
  margin-bottom: 3rem;
  /* margin-left: 18rem; */
}

.form-input, input[type=email], input[type=text] {
  /* width: 50rem; */
  flex: 1;
  height: 6rem;
  border-radius: 1rem;
  padding-bottom: 0;
}
.form-input.--phone {
  width: 42rem;
}
.form-input.--name {
  width: 70rem;
}
.form-input.--password {
  width: 30rem;
}
.form-input.--rePassword {
  width: 45rem;
}

.register-input.--name:after {
  content: "";
  width: 1rem;
  height: 1rem;
  display: inline-block;
  position: absolute;
  margin-top: -.2rem;
  margin-left: 60%;
  background: url(../assets/imgs/required.svg) no-repeat 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.register-input-text {
  font-weight: 600;
  font-size: 1.6rem;
  color: #231815;
  width: 15rem;
  flex-shrink: 0;
}
.invalid-feedback {
  margin-left: 3rem;
  display: block;
  font-weight: 500;
  font-size: 13px;
}

.invalid-feedback:before {
  content: "";
  width: 1rem;
  height: 1rem;
  display: inline-block;
  margin-top: -.2rem;
  margin-right: 1rem;
  background: url(../assets/imgs/required.svg) no-repeat 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.code-btn {
  width: 20rem;
  height: 6rem;
  background-color:#F8F8F8;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  margin-left: .4rem;
  cursor: pointer;
  font-weight: 500;
  font-size: 13px;
}
.register-checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-left: 40rem; */
}

.checkbox {
  min-height: 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  align-items: top;
}
.checkbox__input {
  position: absolute;
  filter: alpha(opacity = 0);
  -moz-opacity: 0;
  -khtml-opacity: 0;
  opacity: 0;
  cursor: pointer;
}
.checkbox__checkmark {
  display: block;
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  margin-top: .2rem;
  margin-right: 1.5rem;
  background: 50% #fff;
  border: .1rem solid #e6e6e6;
  border-radius: .4rem;
  box-sizing: border-box;
  transition-property: all;
  transition-duration: .3s;
  cursor: pointer;
}
.checkbox__label {
  display: block;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  line-height: 2.4rem;
  text-transform: none;
  font-weight: 400;
  color: #4c4c4c;
  letter-spacing: -.009rem;
  /* width: calc(100% - 3.5rem); */
}

.checkbox__input:checked~.checkbox__checkmark {
  background: url(../assets/imgs/icon-check-white.svg) #990099 no-repeat 50%;
  border-color: #990099;
}
.register-checkbox-text {
  color: #5A246B;
  cursor: pointer;
}
.register-btn {
  width: 60rem;
  height: 6rem;
  background-color: #5A246B;
  /* margin-top: 10rem; */
  margin: 10rem auto 0 auto;
  border-radius: 1rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-left: 30rem; */
  cursor: pointer;
  font-weight: 500;
  font-size: 26px;
}
@media (max-width: 1279.9px) {
  .register-input {
    display: block;
  }
  .register-input-text {
    margin-bottom: 1rem;
  }
  .invalid-feedback {
    margin-top: 1rem;
    margin-left: 0;
  }
  .register-checkbox {
    margin: 0;
  }
  .register-btn {
    width: 40rem;
    margin-top: 2rem;
    /* margin-left: 0; */
  }
  .form-input, .form-input.--phone, .form-input.--password, .form-input.--name, .form-input.--rePassword,  input[type=email], input[type=text] {
    width: 40rem;
    height: 6rem;
    border-radius: 1rem;
    padding-bottom: 0;
  }
  .register-header-text h1 {
    font-size: 3rem;
  }
}
@media (max-width: 768px) {
  .register-form {
    padding: 0;
  }
  .register-input{
    margin-left: 0;
  }
  .register-input-text{
    font-size: 1.5rem;
  }
  .invalid-feedback{
    font-size: 1.5rem;
  }
  .form-input{
    width: 100% !important;
  }
  .register-btn{
    width: 100% !important;
  }
  .register-header-text{
    text-align: center;
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/retrievePassword.vue